module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (139).06d272fa.jpg";